// extracted by mini-css-extract-plugin
module.exports = {"MDEditor":"BnXV0"};